<template>
  <div class="rm-screen">
    <div v-if="loading" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!rows.length" class="rm-empty">
      <template v-if="search">{{ $t("report_mobile.no_results_for", { search }) }}</template>
      <template v-else>
        <v-icon size="40" color="#8a817a">{{ emptyIcon }}</v-icon>
        {{ $t("no_data_available") }}
      </template>
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div
          v-for="(stat, index) in stats"
          :key="stat.key"
          class="rm-stat"
          :class="{ 'rm-stat--inverse': index === 0 }"
        >
          <span class="rm-stat__label">{{ stat.label }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="item in rows" :key="item.key" class="rm-mrow">
          <div class="rm-mrow__main">
            <span class="rm-mrow__name">{{ item.name }}</span>
            <span class="rm-mrow__value rm-num">{{ item.total }}</span>
          </div>
          <div v-if="item.shifts.length" class="rm-mrow__shifts">
            <span v-for="shift in item.shifts" :key="shift.id" class="rm-mrow__shift rm-num">
              <report-shift-tag :shift="shift.id"></report-shift-tag>
              {{ shift.quantity }}
            </span>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import ReportShiftTag from "../shared/ReportShiftTag.vue";
import "./screens/reportMobileMealCards.scss";

/**
 * Spisak stavki sa ukupnom količinom i količinom po smeni (Namirnice, Jela na telefonu): dve brojke gore,
 * pa kartica sa redovima. Samo prikazuje; učitavanje, pretraga i izvoz su u ekranu koji ga koristi.
 */
export default {
  name: "ReportMobileShiftRows",
  components: { ReportShiftTag },
  props: {
    loading: { type: Boolean, default: false },
    /** [{ key, name, total, shifts: [{ id, quantity }] }] */
    rows: { type: Array, default: () => [] },
    /** [{ key, label, value }]: prva je istaknuta */
    stats: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    emptyIcon: { type: String, default: "mdi-table" },
  },
};
</script>
